import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IdentiteImmatriculeeDetail } from '@idt-api';

export const IdtActions = createActionGroup({
  source: 'Idt',
  events: {
    'Lire Identite': emptyProps(),
    'Lire Identite Success': props<{ identite: IdentiteImmatriculeeDetail }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Lire Identite Failure': props<{ error: any }>(),
  },
});
